var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49679 0.749512C6.79142 0.749512 7.07386 0.860612 7.28013 1.05696L8.67553 2.3748C8.88328 2.57101 9 2.83712 9 3.1146C9 3.39208 8.88328 3.65819 8.67553 3.8544L3.58087 8.66437C3.26655 9.0068 2.821 9.21718 2.31056 9.25024H0V8.82526L0.00146144 7.03392C0.0397971 6.58579 0.260399 6.16909 0.596922 5.88906L5.71291 1.05747C5.92036 0.860361 6.20249 0.749512 6.49679 0.749512ZM2.27877 8.40141C2.51917 8.38534 2.74294 8.27967 2.92263 8.08556L6.32547 4.87186L4.636 3.27623L1.21323 6.50799C1.03091 6.66028 0.918119 6.87333 0.89998 7.06823V8.40061L2.27877 8.40141ZM5.27247 2.67528L6.96186 4.27084L8.03912 3.25345C8.07809 3.21665 8.09999 3.16673 8.09999 3.11468C8.09999 3.06263 8.07809 3.01271 8.03912 2.9759L6.64247 1.65688C6.60394 1.6202 6.55149 1.59956 6.49677 1.59956C6.44206 1.59956 6.38961 1.6202 6.35108 1.65688L5.27247 2.67528Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7109d4f77f226dc8be47bc58b1fe641d.svg";
export { ForwardRef as ReactComponent };